import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { __ } from "services/Translator";
import { setActiveRef, setView } from "stores/support/supportSlice";
import {
  selectSupportActiveRef,
  selectSupportView,
} from "stores/support/supportSelectors";
import useSupportConfig from "support/hooks/useSupportConfig";
import HomeView from "support/views/HomeView";
import ConversationListView from "support/views/ConversationListView";
import ConversationView from "support/views/ConversationView";
import NewConversationView from "support/views/NewConversationView";
import RgHandoffView from "support/views/RgHandoffView";
import KbSearchView from "support/views/KbSearchView";

// The router-agnostic core. Mode A (slide-over panel) and Mode B (the account
// page) both render this, so views never learn which shell they are inside.
export default function MessengerRoot({ active }) {
  const dispatch = useDispatch();
  const view = useSelector(selectSupportView);
  const activeRef = useSelector(selectSupportActiveRef);
  const { config, loading, error, reload } = useSupportConfig(active);

  const openConversation = (reference) => {
    dispatch(setActiveRef(reference));
    dispatch(setView("conversation"));
  };

  if (loading && !config) {
    return (
      <div className="supState" role="status">
        {__("Loading")}
      </div>
    );
  }

  // Every failure mode has to look the same to the player: with the platform
  // flag off the request does not come back as a parseable error, it comes back
  // as whatever the fallthrough route does, so the UI never reads the body.
  if (error && !config) {
    return (
      <div className="supState supStateError" role="status">
        <p>{__("Support is not available right now.")}</p>
        <button type="button" className="supBtn supBtnGhost" onClick={reload}>
          {__("Try again")}
        </button>
      </div>
    );
  }

  if (!config) {
    return null;
  }

  switch (view) {
    case "list":
      return <ConversationListView active={active} onOpen={openConversation} />;
    case "conversation":
      return <ConversationView reference={activeRef} active={active} config={config} />;
    case "new":
      return <NewConversationView config={config} onCreated={openConversation} />;
    case "kb":
      return <KbSearchView onStartConversation={() => dispatch(setView("new"))} />;
    case "rg":
      return <RgHandoffView config={config} onBack={() => dispatch(setView("home"))} />;
    case "home":
    default:
      return (
        <HomeView
          config={config}
          onStartConversation={() => dispatch(setView("new"))}
          onOpenList={() => dispatch(setView("list"))}
          onOpenKb={() => dispatch(setView("kb"))}
        />
      );
  }
}
